@if (sections().length) {
  <div class="workflow-references-list" data-cy="WorkflowReferencesList">
    @for (section of sections(); track section.title) {
      <div class="workflow-references-list__section-name">{{ section.title }}</div>
      @for (reference of section.references; track reference.workflowId) {
        @let label = formatWorkflowReferenceLabel(reference);
        <button
          type="button"
          class="workflow-references-list__reference"
          (click)="referenceSelected.emit(reference)"
        >
          <mat-icon class="icon-16" svgIcon="icon_search_16" />
          <span class="workflow-references-list__reference-label" [title]="label">
            {{ label }}
          </span>
        </button>
      }
    }
  </div>
}
